// extracted by mini-css-extract-plugin
export default {"arrow":"SfLjF","arrowRight":"JliCV","arrowLeft":"_5KQMP"};